module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("历届年会")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid content-style"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2025年会 · 广州\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2025.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2024年会 · 曼谷\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2024.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2023年会 · 广州\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2023.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2022年会 · 广州\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2022.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-right"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2021年会 · 广州\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2021.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2020年会 · 成都\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2020.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-right"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2019年会 · 新加坡\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2019.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-left"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2018年会 · 澳门\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2018.jpg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 item-padding-right"
  }, [_c('div', {
    staticClass: "item item_height_zh"
  }, [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_c('img', {
    staticClass: "item-title-icon",
    attrs: {
      "src": "imgs/principle_icon_2.png",
      "alt": ""
    }
  }), _vm._v("\n                        2017年会 · 东京\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-splitter"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    attrs: {
      "align": "middle"
    }
  }, [_c('img', {
    staticClass: "image-width",
    attrs: {
      "src": "imgs/culture_nh/2017.jpg",
      "alt": ""
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f70ae7d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/culture_nh.vue
// module id = 108
// module chunks = 19